var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconWrapper } from ".";
export const ClearIcon = React.forwardRef((_a, ref) => {
    var { color } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM14.8292 9.17543C15.1221 9.46832 15.1221 9.9432 14.8292 10.2361L13.0653 11.9999L14.8331 13.7677C15.126 14.0606 15.126 14.5355 14.8331 14.8283C14.5402 15.1212 14.0653 15.1212 13.7724 14.8283L12.0047 13.0606L10.233 14.8323C9.94007 15.1252 9.4652 15.1252 9.17231 14.8323C8.87941 14.5394 8.87941 14.0645 9.17231 13.7716L10.944 11.9999L9.17965 10.2356C8.88676 9.94267 8.88676 9.46779 9.17965 9.1749C9.47255 8.88201 9.94742 8.88201 10.2403 9.1749L12.0047 10.9393L13.7685 9.17543C14.0614 8.88254 14.5363 8.88254 14.8292 9.17543Z" })));
});
//# sourceMappingURL=Clear.js.map